import {
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React, { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useParams } from 'react-router';
import { Issue } from '../../issues/components/issue';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import ActivityEditLabels from './activity-edit-label';
import { ActivityEditColumn } from './activityEditColumn';

export const ActivityEdit = () => {
  const { issueId = '' } = useParams();
  const resetLabelsRef = useRef<(() => void) | undefined>(undefined);
  const [selectedLabels, setSelectedLabels] = useState<
    Array<{ id: string; name: string }> | undefined
  >(undefined);

  const leftColumn = {
    title: 'activities.detail.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue isComingFromActivities />,
  };

  const rightColumn = {
    title: 'issue.menu.edit',
    mainComponent: (
      <ActivityEditColumn
        selectedLabels={selectedLabels}
        onLabelsChange={setSelectedLabels}
      />
    ),
    disableScroll: true,
  };

  const thirdColumn = {
    title: 'issue.new.labels',
    mainComponent: (
      <ActivityEditLabels
        issueId={issueId}
        selectedLabels={selectedLabels ?? []}
        onLabelsChange={setSelectedLabels}
        resetRef={resetLabelsRef}
      />
    ),
    headerComponent: (
      <View style={styles.headerResetButton}>
        <HeaderResetButton 
          onReset={() => resetLabelsRef.current?.()} 
        />
      </View>
    ),
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  headerResetButton: {
    marginRight: 8
  },
});
